import { t } from 'i18next';
import type { ErrorStrategy } from '../types';

export const formatStrategy: ErrorStrategy = ({ instancePath, params }) => {
  return {
    path: instancePath,
    message: t(params.format === 'email' ? 'Validation.EmailAddressIsNotValid' : 'WrongFormat'),
  };
};
